export default function getFunnelChart({
  data,
  values,
  averageValues,
  legends,
  rawDataValues,
  enrollmentsMembershipRawDataLink,
  enrollmentsPackageRawDataLink,
  enrollmentsIntroRawDataLink
}) {
  const result = {
    labels: [],
    subLabels: legends,
    values,
    rawDataValues: rawDataValues,
    subPercents: [""],
    breakdownRawData: [
      enrollmentsMembershipRawDataLink,
      enrollmentsPackageRawDataLink,
      enrollmentsIntroRawDataLink
    ],
    percentLabels: [],
    averageValues: averageValues
  };

  for (const dataValue of data) {
    const { label, percentageData } = dataValue;

    result.labels.push(label);

    if (percentageData.length) {
      const percentLabels = [];

      for (let i = 0; i < percentageData.length; i++) {
        const { label, value } = percentageData[i];
        percentLabels.push(label);

        if (i === 1) {
          result.subPercents.push(value);
        }
      }
      result.percentLabels.push(percentLabels);
    } else {
      // result.subPercents.push(0);
    }
  }

  return result;
}
